<template>
	<div>
		<div class="decade-sep" v-bind:data-decade="rowdata.decade">
			<a v-bind:name="rowdata.decade"></a>
		</div>
		<section
			v-bind:class="
				'up up-' + rowdata.articles.length
			"
		>
			<timeline-single
				v-for="(stop, indexstop) in rowdata.articles"
				v-bind:stopdata="stop"
				v-bind:loopinstance="indexstop"
				v-bind:key="indexstop"
				v-bind:lPos="lPos"
				v-bind:rootPath="rootPath"
				v-bind:apiPath="apiPath"
			></timeline-single>
		</section>
	</div>
</template>

<script>
import TimelineSingle from "./TimelineSingle.vue";
export default {
	created(){
		this.$parent.rowdecades.push(this.rowdata.decade);
	},
	components: {
		TimelineSingle
	},
	props: ['rootPath','apiPath','lPos','activeDecade','rowdata','rowdecades'],
	data() {
		return {};
	}
};
</script>
